import React from "react";
import PropTypes from "prop-types";
import {RedeemGiftCardListener} from "./GiftCard/RedeemGiftCardListener";

export function RedeemGiftOrderListener() {
    
    return (
        <RedeemGiftCardListener/>
    )
    
}

RedeemGiftOrderListener.propTypes = {
    onDismiss: PropTypes.func
}